import * as React from 'react';
import clsx from 'clsx';
import { InstantWinEvent } from 'models/instantWinEvent';
import { Modal } from 'components/Modal/Modal';

import { ImageDownloadCard } from './ImageDownloadCard';

import styles from './ImageDownloadCard.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  instantWinEvent: InstantWinEvent;
}

export const ImageDownloadModal = ({ open, onClose, instantWinEvent }: Props) => {
  const showScrollButtons = (instantWinEvent?.download_items || []).length > 1;
  const sliderRef = React.useRef<HTMLDivElement>(null);

  const scroll = (direction: string) => {
    if (!sliderRef.current) {
      return;
    }

    const slideWidth = sliderRef.current.offsetWidth;
    const currentScroll = sliderRef.current.scrollLeft;

    if (direction === 'prev') {
      sliderRef.current.scrollTo({
        left: currentScroll - slideWidth,
        behavior: 'smooth',
      });
    } else {
      sliderRef.current.scrollTo({
        left: currentScroll + slideWidth,
        behavior: 'smooth',
      });
    }
  };
  return (
    <Modal onClose={onClose} open={open}>
      <div className={clsx(styles['modal__content'])}>
        <div className={styles['sideSlider']}>
          {showScrollButtons && (
            <button className={styles['prev']} onClick={() => scroll('prev')}>
              &lt;
            </button>
          )}
          <div className={clsx(styles['sideSlides'])} ref={sliderRef}>
            {(instantWinEvent?.download_links || []).map((item, index) => (
              <div className={styles['sideSlide']} key={index}>
                <div className={clsx(styles['slideUp__content__list'])}>
                  <ImageDownloadCard
                    imageUrl={item.url ?? ''}
                    mediaType={item.media_type ?? 'IMAGE'}
                  />
                </div>
              </div>
            ))}
          </div>
          {showScrollButtons && (
            <button className={styles['next']} onClick={() => scroll('next')}>
              &gt;
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};
